import * as constants from '@config/constants';

export function getRoleDisplayName(roles) {
  if (roles.includes(constants.ROLE_OWNER)) {
    return constants.ROLE_OWNER;
  }
  if (roles.includes(constants.ROLE_ADMIN)) {
    return constants.ROLE_ADMIN;
  }
  return constants.ROLE_VIEW_ONLY;
}
